export const QUIZ_STEPS = [
  {
    key: "interior",
    eyebrow: "Step 01",
    title: "How's the inside looking?",
    single: true,
    options: [
      { id: 0, label: "Pretty clean", hint: "A little dust, maybe some crumbs" },
      { id: 1, label: "Needs a refresh", hint: "Dirty carpets, smudged console, dull plastics" },
      { id: 2, label: "Rough", hint: "Stains, spills, odors or heavy grime" },
    ],
  },
  {
    key: "exterior",
    eyebrow: "Step 02",
    title: "And the paint?",
    single: true,
    options: [
      { id: 0, label: "Still shines", hint: "Just needs a proper wash" },
      { id: 1, label: "Dull & spotted", hint: "Water spots, road film, no more bead" },
      { id: 2, label: "Swirled or faded", hint: "Scratches, oxidation, chalky trim" },
    ],
  },
  {
    key: "extras",
    eyebrow: "Step 03",
    title: "Anything riding along?",
    single: false,
    options: [
      { id: "paw", label: "Pet hair", hint: "Dogs, cats, the whole crew" },
      { id: "headlight", label: "Foggy headlights", hint: "Yellowed or hazy lenses" },
      { id: "engine", label: "Dirty engine bay", hint: "Dusty, greasy under the hood" },
      { id: "shield", label: "Want lasting protection", hint: "Keep it glossy for months" },
    ],
  },
  {
    key: "goal",
    eyebrow: "Step 04",
    title: "What's the goal?",
    single: true,
    options: [
      { id: "quick", label: "Quick clean-up", hint: "Make it presentable again" },
      { id: "sell", label: "Sell or trade-in ready", hint: "Maximize what it's worth" },
      { id: "show", label: "Show-car finish", hint: "Turn heads in the parking lot" },
    ],
  },
];

export function recommendPackage(answers, packages, addOns) {
  const interior = answers.interior ?? 0;
  const exterior = answers.exterior ?? 0;
  const extras = answers.extras || [];
  const goal = answers.goal || "quick";

  let pkgId = "basic";
  if (interior >= 1 && exterior >= 1) pkgId = "full";
  else if (interior >= 1) pkgId = "interior";
  else if (exterior >= 1) pkgId = "exterior";
  if ((goal === "sell" || goal === "show") && (interior >= 1 || exterior >= 1)) pkgId = "full";
  if (goal === "show" && pkgId === "basic") pkgId = "exterior";

  const pkg = packages.find((p) => p.id === pkgId) || packages[0];

  const wanted = new Set(extras);
  if (exterior >= 2 || goal === "show") wanted.add("buffer");
  if (goal === "show" || goal === "sell") wanted.add("shield");
  const recommendedAddOns = addOns.filter((a) => wanted.has(a.icon));

  const reasons = [];
  if (interior >= 2) reasons.push("Heavy interior grime calls for shampoo + odor treatment.");
  else if (interior === 1) reasons.push("A tired interior gets fully refreshed here.");
  if (exterior >= 2) reasons.push("Swirls and fade need clay + correction, not just a wash.");
  else if (exterior === 1) reasons.push("Clay bar and wax bring the gloss back.");
  if (goal === "sell") reasons.push("A full detail is the highest-ROI move before selling.");
  if (goal === "show") reasons.push("Correction + coating is how you get that wet look.");
  if (!reasons.length) reasons.push("Your car is in good shape — a solid maintenance clean keeps it that way.");

  return { pkg, recommendedAddOns, reasons };
}
